import type { IconKeys } from '#@/components/Icon';
import { BUTTON_VARIANT } from '#@/shared/constants';
import { COLOR } from '#@/shared/utils/styles';

import type { ButtonVariantV2 } from './types';

export const getVariantV2 = (variant: BUTTON_VARIANT, hollow: boolean): ButtonVariantV2 => {
  if (hollow) {
    return {
      [BUTTON_VARIANT.danger]: 'secondaryDanger' as const,
      [BUTTON_VARIANT.primary]: 'secondary' as const,
      [BUTTON_VARIANT.success]: 'secondary' as const,
    }[variant];
  }

  return {
    [BUTTON_VARIANT.danger]: 'primaryDanger' as const,
    [BUTTON_VARIANT.primary]: 'primary' as const,
    [BUTTON_VARIANT.success]: 'primarySuccess' as const,
  }[variant];
};

export const isPrimary = (
  variant: ButtonVariantV2,
): variant is ButtonVariantV2 & `primary${string}` => variant.startsWith('primary');

export const isSecondary = (
  variant: ButtonVariantV2,
): variant is ButtonVariantV2 & `secondary${string}` => variant.startsWith('secondary');

export const isInverted = (
  variant: ButtonVariantV2,
): variant is ButtonVariantV2 & `${string}Inverted` => variant.endsWith('Inverted');

export const getColorFromButtonVariant = (type: ButtonVariantV2): COLOR =>
  ({
    primary: COLOR.brand,
    primarySuccess: COLOR.success,
    primaryDanger: COLOR.danger,
    primaryInverted: COLOR.white,
    secondary: COLOR.brand,
    secondaryBrand: COLOR.brand,
    secondaryDanger: COLOR.danger,
    secondaryInverted: COLOR.white,
    secondaryWarning: COLOR.warning,
  })[type];

export const getDisabledColorFromButtonVariant = (type: ButtonVariantV2): COLOR => {
  if (isInverted(type)) {
    return isPrimary(type) ? COLOR.textSecondary : COLOR.backgroundMedium;
  }
  return COLOR.textTertiary;
};

export const getBadgeColorFromButtonVariant = (type: ButtonVariantV2): COLOR => {
  if (isInverted(type)) {
    return isPrimary(type) ? COLOR.brand : COLOR.white;
  }
  return isPrimary(type) ? COLOR.white : COLOR.textSecondary;
};

export const getIconConfigurationFromOldProps = ({
  icon,
  iconColor,
  iconSize,
  iconPosition,
}: {
  icon: IconKeys;
  iconColor?: COLOR;
  iconSize?: number;
  iconPosition: 'left' | 'right';
}) => {
  const config = {
    type: icon,
    color: iconColor,
    size: iconSize,
  };

  return iconPosition === 'left' ? { iconLeft: config } : { iconRight: config };
};
